import React from "react";

const SvgSearch = props => (
  <svg viewBox={props.viewBox ? props.viewBox : "0 0 200 200"} {...props}>
    <path
      d="M160.87 165.08a4.68 4.68 0 01-3.33-1.37l-37.08-36.62a4.74 4.74 0 116.66-6.74L164.2 157a4.74 4.74 0 01-3.33 8.11zm-78.2-33.66a48.13 48.13 0 01-33.93-13.91 48.34 48.34 0 1133.93 13.91zM55.4 110.77a38.8 38.8 0 10-11.53-27.36 38.84 38.84 0 0011.53 27.36z"
      data-name="Obecn\xE9 ikony"
    />
  </svg>
);

export default SvgSearch;

